import { EmployeePosition } from '../positionChange/types';
import { buildPositionTree } from '../positionChange/utils';

export const getSmartTreesForPositions = (
  allPositions: EmployeePosition[],
  currentPositionId: string,
  selectedPositionId?: string,
): EmployeePosition[] => {
  if (!selectedPositionId || selectedPositionId === currentPositionId) {
    // No selection or selected same as current - show current position's tree
    return getFullTreeForPosition(allPositions, currentPositionId);
  }

  // Check if selected position is in the same tree as current position
  const currentPositionTree = getFullTreeForPosition(
    allPositions,
    currentPositionId,
  );
  const isSelectedInCurrentTree = currentPositionTree.some(
    (pos) => pos.Id === selectedPositionId,
  );

  if (isSelectedInCurrentTree) {
    // Same tree - show the shared tree
    return currentPositionTree;
  } else {
    // Different trees - show both trees
    const selectedPositionTree = getFullTreeForPosition(
      allPositions,
      selectedPositionId,
    );

    // Combine both trees, avoiding duplicates
    const combinedPositions = [...currentPositionTree];
    selectedPositionTree.forEach((pos) => {
      if (!combinedPositions.some((existing) => existing.Id === pos.Id)) {
        combinedPositions.push(pos);
      }
    });

    return combinedPositions;
  }
};

export const getFullTreeForPosition = (
  allPositions: EmployeePosition[],
  positionId: string,
): EmployeePosition[] => {
  const treeComponents = buildPositionTree(allPositions, positionId);

  const targetTreeComponent = treeComponents.find((component) =>
    component.includes(positionId),
  );

  if (!targetTreeComponent) {
    const position = allPositions.find((pos) => pos.Id === positionId);
    return position ? [position] : [];
  }

  return allPositions.filter((pos) => targetTreeComponent.includes(pos.Id));
};
